import { filter } from "lodash";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Card,
  Table,
  Stack,
  TableRow,
  TableBody,
  TableCell,
  Typography,
  TableContainer,
  TablePagination,
} from "@mui/material";
import Label from "src/components/Label";
import { UserListHead } from "src/components/_dashboard/user";
import { CircularProgress } from "@mui/material";
import { useSnackbar } from "notistack";
import { makeStyles } from "@mui/styles";
import { htmlDecode } from "src/utils/convertHtml";
import CustomPopoverSection from "src/components/MenuOption/CustomPopoverSection";
import {
  ExerciseTypeListingApi,
  deleteExerciseTypeApi,
} from "src/DAL/exerciseType/exerciseType";
import UserListToolbars from "src/components/_dashboard/user/UserListToolbars";
import SearchNotFound from "src/components/SearchNotFound";
import CustomConfirmation from "src/components/menuIcons/CustomConfirmation";

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(
      array,
      (_user) =>
        _user?.fullName?.toLowerCase().indexOf(query?.toLowerCase()) !== -1,
    );
  }
  return stabilizedThis.map((el) => el[0]);
}

const useStyles = makeStyles(() => ({
  loading: {
    marginLeft: "50%",
    marginTop: "20%",
  },
}));

const tabs = {
  all: "",
  asc: "asc",
  desc: "desc",
  trash: "trash",
};

export default function ExercisListingType() {
  const navigate = useNavigate();
  const classes = useStyles();
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState("asc");
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState("number");
  const [filterName, setFilterName] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [userList, setUserList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [deleteDoc, setDeleteDoc] = useState("");
  const [openDelete, setOpenDelete] = useState(false);
  const [showColm, setShowColm] = useState(false);
  const [selectedTab, setSelectedTab] = useState(tabs.asc);

  const TABLE_HEAD = [
    { id: "number", label: "#", alignRight: false },
    { id: "title", label: " Title", alignRight: false },
    { id: "des", label: "Description", alignRight: false },

    { id: "status", label: "Status", alignRight: false },
  ];
  if (showColm) {
    TABLE_HEAD.unshift({ id: "action", label: "Action", alignRight: false });
  }

  const getExerciseTypeListing = async () => {
    setIsLoading(true);
    const result = await ExerciseTypeListingApi(
      page,
      rowsPerPage,
      filterName,
      selectedTab,
    );
    if (result.code === 200) {
      result.exercise_types.map((item) => {
        if (item.action_by) {
          setShowColm(true);
          return;
        }
      });
      setUserList(result.exercise_types);
      setIsLoading(false);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
      setIsLoading(false);
    }
  };

  const handleEdit = (value) => {
    navigate(`/type-exercise-edit/${value?.exercise_type_slug}`, {
      state: value,
    });
  };

  const handleAgreeDelete = (value) => {
    setDeleteDoc(value);
    setOpenDelete(true);
  };

  const handleDelete = async () => {
    setOpenDelete(false);
    setIsLoading(true);
    const result = await deleteExerciseTypeApi(deleteDoc.exercise_type_slug);
    if (result.code === 200) {
      getExerciseTypeListing();
      enqueueSnackbar(result.message, { variant: "success" });
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
      setIsLoading(false);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const Capitalize = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  const handleNavigate = () => {
    navigate(`/type-exercise-add`);
  };

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - userList.length) : 0;

  const filteredUsers = applySortFilter(
    userList,
    getComparator(order, orderBy),
    filterName,
  );

  useEffect(() => {
    getExerciseTypeListing();
  }, [rowsPerPage, page, selectedTab]);

  const MENU_OPTIONS1 = [
    {
      label: "Edit",
      icon: "akar-icons:edit",
      handleClick: handleEdit,
    },

    {
      label: "Delete",
      icon: "ant-design:delete-twotone",
      handleClick: handleAgreeDelete,
    },
  ];
  const isUserNotFound = filteredUsers.length === 0;

  if (isLoading == true) {
    return <CircularProgress className={classes.loading} color="primary" />;
  }

  return (
    <>
      <CustomConfirmation
        open={openDelete}
        setOpen={setOpenDelete}
        title={"Are you sure you want to delete ?"}
        handleAgree={handleDelete}
      />

      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-8 col-sm-12">
            <h2>Exercies Type</h2>
          </div>
          <div className="col-lg-4 col-sm-12 text-end">
            <button onClick={handleNavigate} className="small-contained-button">
              Add Type
            </button>
          </div>
        </div>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mt={5}
          mb={1}
        >
          <div className="d-flex">
            <div className="me-2 pointer">
              <Label
                onClick={() => setSelectedTab(tabs.asc)}
                variant={selectedTab === tabs.asc ? "ghost" : ""}
                style={{ width: 50, cursor: "pointer" }}
                color="info"
              >
                A-Z
              </Label>
            </div>
            <div className="me-2 pointer">
              <Label
                onClick={() => setSelectedTab(tabs.desc)}
                variant={selectedTab === tabs.desc ? "ghost" : ""}
                style={{ width: 50, cursor: "pointer" }}
                color="info"
              >
                Z-A
              </Label>
            </div>
          </div>
        </Stack>
        <Card style={{ overflowX: "auto" }}>
          <div className="col-lg-12 col-sm-12 d-flex justify-content-end">
            <UserListToolbars
              numSelected={selected.length}
              filterName={filterName}
              onFilterName={handleFilterByName}
              onSearch={() => getExerciseTypeListing()}
            />
          </div>

          <TableContainer sx={{ minWidth: 800 }}>
            <Table>
              <UserListHead
                order={order}
                orderBy={orderBy}
                headLabel={TABLE_HEAD}
                rowCount={userList.length}
                numSelected={selected.length}
              />
              <TableBody>
                {filteredUsers
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, i) => {
                    const { id, name, action_by, status, title, description } =
                      row;
                    const isItemSelected = selected.indexOf(name) !== -1;
                    return (
                      <TableRow
                        hover
                        key={id}
                        tabIndex={-1}
                        role="checkbox"
                        selected={isItemSelected}
                        aria-checked={isItemSelected}
                      >
                        {showColm && (
                          <TableCell>
                            {action_by === "coach_user" && (
                              <CustomPopoverSection
                                menu={MENU_OPTIONS1}
                                data={row}
                              />
                            )}
                          </TableCell>
                        )}
                        <TableCell align="left">
                          {page * rowsPerPage + (i + 1)}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          <Stack
                            direction="row"
                            alignItems="center"
                            spacing={2}
                          >
                            <Typography variant="subtitle2" noWrap>
                              {title}
                            </Typography>
                          </Stack>
                        </TableCell>

                        <TableCell component="th" scope="row">
                          {Capitalize(htmlDecode(description))}
                        </TableCell>

                        <TableCell align="left">
                          <Label
                            variant="ghost"
                            color={status === false ? "error" : "success"}
                          >
                            {status === false ? "InActive" : "Active"}
                          </Label>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                {emptyRows > 0 && (
                  <TableRow style={{ height: 53 * emptyRows }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
              {isUserNotFound && (
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                      <SearchNotFound searchQuery={filterName} />
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>

          <TablePagination
            rowsPerPageOptions={[50, 100, 150]}
            component="div"
            count={userList.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </div>
    </>
  );
}
